import gql from 'graphql-tag';

const getLocales = gql`
    query locales {
        store {
            multilingualCoursesEnabled
        }
        locales(order: { field: name, direction: asc }) {
            edges {
                node {
                    id
                    code
                    name
                    language
                    default
                }
            }
        }
    }
`;

export default { getLocales };
